import React from 'react';
import { kings, imperial, designModo, mrcLogo, linkedIn, twitter, message, instagram, reseachGate, linkedInOrange } from "../../../img/logo/index.js";
import {josephLevermore, stephanieWright, frankKelly} from "../../../img/team/index.js";
import {labImage, wasteImage} from "../../../img/environmentalImages/index.js";
import "./Homepage.css";
// meta data
import MetaTags from '../metaTags/MetaTags.js';
import { pageMetaTags } from '../metaTags/MetaData.js';
import ParallaxHero from './Components/LandingParralex.js';
import BusinessSection from './Components/BusinessSection.js';
import ReportBanner from './Components/ReportBanner.js';
import ChemicalBurdenHighlight from './Components/ChemicalBurdenHighlights.js';
import NewsSection from './Components/NewsSection.js';
import HeadlineSection from './Components/HeadlineSection.js';
import SpectralLibrarySection from './Components/SpectralLibrary.js';
import PlasticSphereSection from './Components/PlasticSphere.js';
import NewsletterSignup from '../newsletter/newsletter.js';

function Homepage () {
  const meta = pageMetaTags.home;
  // console.logmeta)
	return(
		<React.Fragment>
			<MetaTags 
        title={meta.title}
        description={meta.description}
        url={meta.url}
        image={meta.image}
        siteName={meta.siteName}
        twitterCard={meta.twitterCard}
        twitterSite={meta.twitterSite}
        fbAppId={meta.fbAppId}
			/>
      <ParallaxHero />
      <SpectralLibrarySection/>
      <ReportBanner />
      <NewsSection />
      <NewsletterSignup />
		</React.Fragment>
	);
}

export default Homepage;


